<template>
  <div class="leave">
    <div class="leave__header">
      <h1>Leave</h1>
    </div>

    <div class="leave__body">
      <div class="leave__body--alert" v-if="errStatus">{{ errMessage }}</div>
      <div class="leave__body--loader" v-if="pageLoader">
        <PageLoader />
      </div>

      <div class="leave__body--list" v-if="!pageLoader">
        <p>These are the leave types currently offered.</p>
        <div>
          <div v-for="(leave, index) in leaveData" :key="index">
            <div class="leave__body--list-sick">
              <div>
                <img :src="leave.icon" alt="leave.type" v-if="leave.icon" />
                <img
                  src="../../../assets/images/man.svg"
                  alt="leave.type"
                  v-if="!leave.icon"
                />
              </div>
              <span>{{ leave.type }}</span>
              <p>Max days  <small>(working)</small>: {{ leave.maximum_days }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="leave__body--request" v-if="!pageLoader">
        <div class="leave__body--request-p">Your Leave requests</div>
        <div class="leave__body--request-btn" @click="requestForLeave">
          Request for leave
        </div>
      </div>

      <EmptyContent title="No leave request submitted" v-if="leaveRequest.length < 1"/>


      <div class="leave__body--history" v-if="!pageLoader">
        <div v-for="(leave, index) in leaveRequest" :key="index">
          <div class="leave__body--history-card">
            <div class="leave__body--history-card-major">
              <div class="leave__request--key">Leave Type:</div>
              <div class="leave__request--value">
                {{ leave.leave_type.type }}
              </div>
            </div>
            <div class="leave__body--history-card-minor">
              <div class="leave__request--key">Number of days:</div>
              <div class="leave__request--value">{{ leave.no_of_days }}</div>
            </div>
            <div class="leave__body--history-card-minor">
              <div class="leave__request--key">From:</div>
              <div class="leave__request--value">{{ leave.start_date }}</div>
            </div>
            <div class="leave__body--history-card-minor">
              <div class="leave__request--key">To:</div>
              <div class="leave__request--value">{{ leave.end_date }}</div>
            </div>
            <div class="leave__body--history-card-major">
              <div class="leave__request--key">Reason:</div>
              <div class="leave__request--value">{{ leave.reason }}</div>
            </div>
            <div class="leave__body--history-card-none">
              <div class="leave__request--key">Approver:</div>
              <div class="leave__request--value">
                {{ leave.approval.firstname }} {{ leave.approval.lastname }}
              </div>
            </div>
            <div
              class="leave__body--history-card-minor"
              v-if="leave.line_manager"
            >
              <div class="leave__request--key">Line Manager:</div>
              <div class="leave__request--value">
                {{ leave.line_manager.firstname }}
                {{ leave.line_manager.lastname }}
              </div>
            </div>
            <div class="leave__body--history-card-minor">
              <div class="leave__request--key">Approval Status:</div>
              <div class="leave__request--value" v-if="leave.status === 2">
                <span style="color: red;">
                  <font-awesome-icon icon="times" />
                </span>
                Rejected
              </div>
              <div class="leave__request--value" v-if="leave.status === 0">
                <span style="color: rgba(0, 0, 0, 0.5);">
                  <font-awesome-icon icon="exclamation-triangle" />
                </span>
                Pending
              </div>
              <div class="leave__request--value" v-if="leave.status === 1">
                <span style="color: green;">
                  <font-awesome-icon icon="check" />
                </span>
                Approved
              </div>
              <div class="leave__request--value" v-if="leave.status === 3">
                <span style="color: red;">
                  <font-awesome-icon icon="times" />
                </span>
                Cancelled
              </div>
            </div>
            <div
              class="leave__body--history-card-minor"
              v-if="leave.status === 3"
            >
              <div class="leave__request--key">Reason:</div>
              <div class="leave__request--value">
                {{ leave.cancelled_reason }}
              </div>
            </div>

            <div
              class="leave__body--history-card-btn"
              v-if="leave.status === 3"
            >
              <div>Cancelled</div>
            </div>
            <div
              class="leave__body--history-card-btn-blue"
              v-if="leave.status === 0"
            >
              <div @click="cancelLeave(leave.id)">Cancel</div>
            </div>
          </div>
        </div>
      
      </div>
    </div>

    <div class="leave__modal" v-if="modal">
      <div>
        <div class="leave__modal--container">
          <p>
            <span @click="closeModal">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <div>
            <div class="leave__modal--container-head">
              <span>Lets Setup Your Leave</span>
              <p>
                Ready to take sometime off? Fill the form and you will get an
                email once your employee approves your request
              </p>
            </div>
            <div class="leave__modal--container-type">
              <p>What type of leave do you want to request for?</p>
              <div>
                <div v-for="(leave, index) in leaveData" :key="index">
                  <div
                    @click="selectedLeaveType(leave.id, leave.no_of_days)"
                    v-if="selectedLeave !== leave.id"
                    class="leave__modal--container-type-hover"
                  >
                    <div>
                      <img
                        src="../../../assets/images/sick.svg"
                        alt="sick leave"
                      />
                    </div>
                    <span>{{ leave.type }}</span>
                    <p>Max days  <small>(working)</small>: {{ leave.maximum_days }}</p>
                  </div>

                  <div
                    v-if="selectedLeave === leave.id"
                    class="leave__modal--container-type-selected"
                  >
                    <div>
                      <img
                        src="../../../assets/images/sick.svg"
                        alt="sick leave"
                      />
                    </div>
                    <span>{{ leave.type }}</span>
                    <p>Max days  <small>(working)</small>: {{ leave.maximum_days }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="leave__modal--container-dropdown">
              <div>
                <p>Start date?</p>
                <input type="date" v-model="leaveRequestdata.start_date" />
              </div>
              <div>
                <p>End date?</p>
                <input type="date" v-model="leaveRequestdata.end_date" />
              </div>
              <div>
                <p>How many days out of total possible days are you taking?</p>
                <input type="text" v-model="leaveRequestdata.no_of_days" />
              </div>
            </div>
            <div class="leave__modal--container-note">
              <p>Add a note</p>
              <textarea v-model="leaveRequestdata.reason"></textarea>
            </div>

            <div class="leave__modal--container-btn">
              <div
                class="leave__modal--container-btn-send"
                @click="createLeave"
                v-if="!btnLoader"
              >
                Send Request
              </div>
              <div class="leave__modal--container-btn-send" v-if="btnLoader">
                <WhiteLoader />
              </div>

              <div
                class="leave__modal--container-btn-cancel"
                @click="closeModal"
              >
                Cancel
              </div>
            </div>
            <div class="leave__body--alert" v-if="errStatus">
              {{ errMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="reason__modal" v-if="cancelModal">
      <div>
        <div class="reason__modal--container">
          <p>
            <span @click="closeCancelModal">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <div>
            <textarea
              placeholder="State your reasons."
              v-model="cancelReason"
            ></textarea>
            <div v-if="!cancelLoader" @click="sendCancelledLeaverequest">
              Send
            </div>
            <div v-if="cancelLoader">
              <WhiteLoader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";
import EmptyContent from "../../partials/emptyContent";


export default {
  name: "Leave",

  components: {
    PageLoader,
    WhiteLoader,
    EmptyContent
  },

  data() {
    return {
      item: "leave",
      modal: false,
      cancelModal: false,
      pageLoader: true,
      btnLoader: false,
      cancelLoader: false,
      cancelReason: "",
      cancelledLeaveId: null,
      errMessage: null,
      errStatus: false,
      leaveData: [],
      leaveRequest: [],
      selectedLeave: null,
      selectedLeaveDays: null,
      leaveRequestdata: {
        leave_type_id: null,
        start_date: "",
        end_date: "",
        no_of_days: "",
        reason: ""
      }
    };
  },

  mounted() {
    this.getLeaves();
  },
  methods: {
    getLeaves() {
      this.$http
        .get(types.LEAVE)
        .then(resp => {
          this.leaveData = [...resp.data.data.leaveOptions];
          this.leaveRequest = [...resp.data.data.leaveRequests];
          this.pageLoader = false;
        })
        .catch(err => {
          this.errMessage =
            "Your leave has not been setup. please contact admin.";
          this.errStatus = true;
          this.pageLoader = false;
        });
    },
    selectedLeaveType(val, days) {
      this.errMessage = null;
      this.errStatus = false;
      this.selectedLeave = val;
      this.leaveRequestdata.leave_type_id = val;
      this.selectedLeaveDays = days;
    },
    createLeave() {
      this.errMessage = null;
      this.errStatus = false;

      if (this.leaveRequestdata.leave_type_id === null) {
        this.errMessage = "Please select the leave type.";
        this.errStatus = true;
        return;
      }

      if (this.leaveRequestdata.start_date.trim() === "") {
        this.errMessage = "Please start date.";
        this.errStatus = true;
        return;
      }

      if (this.leaveRequestdata.end_date.trim() === "") {
        this.errMessage = "Please end date.";
        this.errStatus = true;
        return;
      }

      if (this.leaveRequestdata.no_of_days.trim() === "") {
        this.errMessage = "Please enter the number of days.";
        this.errStatus = true;
        return;
      }

      if (this.leaveRequestdata.reason.trim() === "") {
        this.errMessage =
          "Please enter the reason why we should approve this leave.";
        this.errStatus = true;
        return;
      }

      const onlyDigits = /^[0-9]*$/;

      if (!onlyDigits.test(this.leaveRequestdata.no_of_days)) {
        this.errMessage = "Please enter the number of days.";
        this.errStatus = true;
        return;
      }

      if (this.selectedLeaveDays < 1) {
        this.errMessage =
          "Number of of days for the requested leave is not set.";
        this.errStatus = true;
      }

      this.btnLoader = true;

      this.$http
        .post(types.LEAVE, this.leaveRequestdata)
        .then(resp => {
          this.btnLoader = false;
          this.modal = false;
          this.getLeaves();
        })
        .catch(err => {
          this.errMessage =
            "We encountered an error. please check the start date and end date to be sure it does not exceed the number of days selected. Also make sure you don't have a pending application or try again later.";
          this.errStatus = true;
          this.btnLoader = false;
          this.modal = false;
        });
    },
    cancelLeave(val) {
      this.cancelledLeaveId = val;
      this.cancelModal = true;
      this.errMessage = null;
      this.errStatus = false;
    },
    requestForLeave() {
      this.modal = true;
      this.errMessage = null;
      this.errStatus = false;
    },
    closeModal() {
      this.modal = false;
      this.errMessage = null;
      this.errStatus = false;
    },
    closeCancelModal() {
      this.cancelModal = false;
      this.cancelReason = null;
      this.cancelledLeaveId = null;
    },
    sendCancelledLeaverequest() {
      if (this.cancelReason.trim() === "") {
        this.errMessage =
          "Please state your reason for cancelling the request.";
        this.errStatus = true;
        this.cancelModal = false;
        return;
      }

      this.cancelLoader = true;

      const cancelPayload = {
        request_id: this.cancelledLeaveId,
        reason: this.cancelReason
      };

      this.$http
        .patch(types.LEAVE, cancelPayload)
        .then(resp => {
          this.getLeaves();
          this.cancelModal = false;
          this.pageLoader = true;
        })
        .catch(err => {
          this.errMessage = "Server error. please try again later.";
          this.errStatus = true;
          this.cancelModal = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-loader {
  margin-top: 50px;

  > div {
    width: 55px;
    margin: auto;
  }
}

.leave {
  padding-top: 40px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  .leave__header {
    overflow: hidden;
    padding-bottom: 5px;

    > h1 {
      padding-bottom: 5px;
      margin-left: 15px;
      margin-top: 0;
      font-size: 2em;
      margin-left: 0;
      margin-bottom: 0;
    }
  }

  > .leave__body {
    border-top: 1px solid #caced5;
    padding: 20px 5px 0 5px;

    > .leave__body--alert {
      padding: 10px;
      margin: 10px 0;
      text-align: left;
      color: #fff;
      background: rgba(255, 0, 0, 0.64);
      border: 1px solid red;
      font-size: 14px;
      font-style: italic;
    }

    > .leave__body--loader {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      align-content: center;
    }

    > .leave__body--list {
      margin-bottom: 50px;

      > p {
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        align-content: center;

        @media (max-width: 600px) {
          flex-direction: column;
          flex-wrap: wrap;
        }

        > div {
          width: 33.33333333%;
          max-width: 300px;
          margin-top: 20px;
          padding: 0 20px;

          @media (max-width: 900px) {
            padding: 0 10px;
          }

          @media (max-width: 600px) {
            width: 100%;
          }

          > .leave__body--list-sick {
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            background-color: #ffffff;
            padding: 20px;

            > span {
              font-size: 16px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.54;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
            }

            > p {
              font-size: 14px;
              font-weight: 300;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.82;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              margin-top: 5px;
              margin-bottom: 0;
            }

            > div {
              width: 40px;
              height: 40px;
              margin-bottom: 20px;
            }
          }

          > .leave__body--list-annual {
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            background-color: #ffffff;
            padding: 20px;

            > span {
              font-size: 16px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.54;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
            }

            > p {
              font-size: 14px;
              font-weight: 300;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.82;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              margin-top: 5px;
              margin-bottom: 0;
            }

            > div {
              width: 40px;
              height: 40px;
              margin-bottom: 20px;
            }
          }

          > .leave__body--list-casual {
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
            background-color: #ffffff;
            padding: 20px;

            > span {
              font-size: 16px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.54;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
            }

            > p {
              font-size: 14px;
              font-weight: 300;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.82;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              margin-top: 5px;
              margin-bottom: 0;
            }

            > div {
              width: 40px;
              height: 40px;
              margin-bottom: 20px;
            }
          }
        }
      }
    }

    > .leave__body--request {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      align-content: center;
      padding: 10px 20px;
      border-bottom: 1px solid #000000;
      margin-bottom: 20px;

      > .leave__body--request-p {
        width: 170px;
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.9;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > .leave__body--request-btn {
        width: 150px;
        border-radius: 3px;
        background-color: #5099de;
        font-size: 14px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        padding: 10px 0;
        cursor: pointer;
      }
    }

    > .leave__body--history {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: flex-start;
      align-content: center;

      > div {
        width: 33.33333333%;
        max-width: 300px;
        padding: 10px;

        @media (max-width: 1000px) {
          width: 50%;
        }

        @media (max-width: 600px) {
          width: 600%;
        }

        > .leave__body--history-card {
          border-radius: 3px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
          background-color: #ffffff;
          padding: 10px;
          > .leave__body--history-card-major {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: center;
            align-content: center;
            border-bottom: 1px solid #000;
            margin-bottom: 10px;
          }

          > .leave__body--history-card-minor {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: center;
            align-content: center;
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);
            margin-bottom: 10px;
          }

          > .leave__body--history-card-none {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: center;
            align-content: center;
            margin-bottom: 10px;
          }

          > .leave__body--history-card-btn {
            margin-top: 20px;

            > div {
              width: 100px;
              margin: auto;
              border-radius: 3px;
              font-size: 14px;
              font-weight: 300;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.5;
              letter-spacing: normal;
              text-align: center;
              color: #ccc;
              padding: 10px 0;
              border: 1px solid #ccc;
            }
          }

          > .leave__body--history-card-btn-blue {
            margin-top: 20px;

            > div {
              width: 100px;
              margin: auto;
              border-radius: 3px;
              font-size: 14px;
              font-weight: 300;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.5;
              letter-spacing: normal;
              text-align: center;
              color: #5099de;
              padding: 10px 0;
              border: 1px solid #5099de;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .leave__request--key {
    width: 50%;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #707070;
  }

  .leave__request--value {
    width: 50%;
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
  }

  .leave__modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    overflow: auto;

    > div {
      max-width: 800px;
      margin: 50px auto;
      padding: 0 10px;

      > .leave__modal--container {
        background-color: #fff;
        padding: 10px 20px;

        > p {
          text-align: right;

          > span {
            color: #000;
            cursor: pointer;
          }
        }

        > div {
          margin-top: 30px;

          > .leave__modal--container-head {
            > span {
              font-size: 20px;
              font-weight: 600;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
            }

            > p {
              font-size: 16px;
              font-weight: 200;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.67;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              margin: 10px 0 0 0;
            }
          }

          > .leave__modal--container-type {
            margin-top: 20px;
            > p {
              font-size: 18px;
              font-weight: 600;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.82;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }

            > div {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              align-items: center;
              justify-content: flex-start;
              align-content: center;

              > div {
                width: 30%;
                padding: 0 5px;
                margin-top: 20px;

                > .leave__modal--container-type-hover {
                  border-radius: 5px;
                  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
                  background-color: #ffffff;
                  padding: 10px;
                  cursor: pointer;

                  &:hover {
                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
                    background-color: #5099de;

                    > span {
                      color: #fff;
                    }

                    > p {
                      color: #fff;
                    }
                  }

                  > div {
                    width: 40px;
                    height: 40px;
                    margin-bottom: 10px;

                    > img {
                      width: 100%;
                      height: 100%;
                    }
                  }

                  > span {
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2;
                    letter-spacing: normal;
                    text-align: center;
                    color: #000000;
                  }

                  > p {
                    font-size: 14px;
                    font-weight: 300;
                    font-stretch: normal;
                    font-style: normal;
                    text-align: left;
                    color: #000000;
                  }
                }

                > .leave__modal--container-type-selected {
                  border-radius: 5px;
                  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
                  background-color: #5099de;
                  padding: 10px;
                  cursor: pointer;

                  > div {
                    width: 40px;
                    height: 40px;
                    margin-bottom: 10px;

                    > img {
                      width: 100%;
                      height: 100%;
                    }
                  }

                  > span {
                    font-size: 16px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2;
                    letter-spacing: normal;
                    text-align: center;
                    color: #fff;
                  }

                  > p {
                    font-size: 14px;
                    font-weight: 300;
                    font-stretch: normal;
                    font-style: normal;
                    text-align: left;
                    color: #fff;
                  }
                }
              }
            }
          }

          > .leave__modal--container-dropdown {
            margin-top: 20px;

            > div {
              margin-bottom: 20px;

              > p {
                font-size: 14px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.82;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                margin-bottom: 5px;
              }

              > input {
                width: 200px;
                height: 40px;
                border-radius: 5px;
                border: solid 1px #707070;
                background-color: #ffffff;
                outline: 0;
                padding: 0 5px;
                font-size: 14px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: 2;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
              }
            }
          }

          > .leave__modal--container-note {
            margin-top: 20px;

            > p {
              font-size: 14px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.82;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
              margin-bottom: 5px;
            }

            > textarea {
              max-width: 500px;
              height: 100px;
              border-radius: 5px;
              border: solid 1px #707070;
              background-color: #ffffff;
              padding: 10px;
              resize: none;
              outline: none;
              font-size: 14px;
            }
          }

          > .leave__modal--container-btn {
            width: 270px;
            margin: 20px auto;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: space-between;
            align-content: center;

            > .leave__modal--container-btn-send {
              width: 45%;
              height: 40px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: center;
              color: #ffffff;
              border-radius: 5px;
              background-color: #5099de;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              cursor: pointer;
            }

            > .leave__modal--container-btn-cancel {
              width: 45%;
              height: 40px;
              font-size: 12px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: center;
              color: #5099de;
              border-radius: 5px;
              border: solid 1px #5099de;
              background-color: #ffffff;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              cursor: pointer;
            }
          }

          > .leave__body--alert {
            padding: 10px;
            margin: 10px 0;
            text-align: left;
            color: #fff;
            background: rgba(255, 0, 0, 0.64);
            border: 1px solid red;
            font-size: 14px;
            font-style: italic;
          }
        }
      }
    }
  }

  .reason__modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    overflow: auto;

    > div {
      max-width: 400px;
      margin: 50px auto;
      padding: 0 10px;

      > .reason__modal--container {
        background-color: #fff;
        padding: 10px 20px;

        > p {
          text-align: right;

          > span {
            color: #000;
            cursor: pointer;
          }
        }

        > div {
          margin-top: 30px;

          > textarea {
            height: 200px;
            border: 1px solid #ddd;
            outline: none;
            padding: 5px;
            margin-bottom: 10px;
            font-size: 14px;
            resize: none;
          }

          > div {
            width: 100%;
            height: 40px;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            border-radius: 5px;
            background-color: #5099de;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
